import axios from './http'
import de from "element-ui/src/locale/lang/de";

/**
 * 新闻
 * @type {{logout(): Promise<AxiosResponse<*>>, login(*=, *=): Promise<AxiosResponse<*>>}}
 */
const notice = {

  /**
   * 管理员获取所有的-加急的放前面-时间倒序
   * @returns {Promise<AxiosResponse<any>>}
   */
  getAll() {
    return axios.get('/thesis/news/getAll')
  },

  /**
   * 添加一条新闻
   * @param newsNotice
   */
  addNewsNotice(newsNotice) {
    return axios.post('/thesis/news',newsNotice)
  },

  /**
   * 删除新闻
   * @param id  用户id
   */
  delById(id){
    return axios.delete('/thesis/news/'+id);
  },

  /**
   * 修改新闻
   * @param newsNotice
   * @returns {Promise<AxiosResponse<any>>}
   */
  update(newsNotice){
    return axios.put('/thesis/news',newsNotice)
  },

  /**
   * 获取一条新闻
   * @param id
   */
  getById(id){
    return axios.get('/thesis/news/'+id)
  }
}


export default notice



// WEBPACK FOOTER //
// ./src/api/notice.js